import { useEffect, useState } from "react";
import tw from "twin.macro";
// import SliderImage from "react-zoom-slider";
import { likeCount, wishCount } from "../api/ProducDetailsApi";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Noimg from "../images/no_img.jpg";
import { getProduct } from "api/ProductApi";
import {
  currentDate,
  currentDateToUtcDate,
  currentRegister,
  filterFormatToDate,
  YEAR_WISE_FORMAT,
} from "utility/Constant";
import styled from "styled-components";
import {
  getAddToCart,
  getBranchId,
  getCustomerAddress,
  getCustomerId,
  getCustomerMail,
  getCustomerName,
  setAddToCart,
} from "../utility/HeaderConfig.js";
import {
  deleteCustomerLike,
  createCustomerLike,
  createCustomerWish,
  deleteCustomerWish,
} from "api/Like&WishCountApi";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import toast, { Toaster } from "react-hot-toast";
// import Pincode from "components/Pincode";
import BookAppointmentButton from "components/BookAppointmentButton";
import ProductPriceDetails from "components/ProductPriceDetails";
import { useCartContext } from "context/UseCartContext";
import RelatedProduct from "components/RelatedProduct";
import Magnifier from "../components/Magnifier";
// import ReactImageMagnify from 'react-image-magnify';
import { Carousel } from "react-responsive-carousel";
import { dayClose } from "api/NewSchemeApi";
import moment from "moment";
import { branchdetails } from "api/BranchDetailsApi";
import { ECommerce } from "api/AppConfigApi";
import tryit from "../../src/images/Thanshiq/try-it-on-camera-icon.svg"
import Select from 'react-select'
import countryList from 'react-select-country-list'
import { useMemo } from "react";
import pdb1 from "../../src/images/imgT1.jpg"
import offerTag from "../../src/images/Thanshiq/diamond mainpage/offers-tag.svg"
import Collapse from 'react-bootstrap/Collapse';
import a1 from "../../src/images/Thanshiq/Dazzling_Grace_Drop_Earrings/A1.png"
import a2 from "../../src/images/Thanshiq/Dazzling_Grace_Drop_Earrings/A2.png"
import a3 from "../../src/images/Thanshiq/Dazzling_Grace_Drop_Earrings/A3.png"
import a4 from "../../src/images/Thanshiq/Dazzling_Grace_Drop_Earrings/A4.png"
import ad from "../../src/images/Thanshiq/Dazzling_Grace_Drop_Earrings/Ad.png"
import anright from "../../src/images/Thanshiq/Dazzling_Grace_Drop_Earrings/icons8-right.gif"
import rightA from "../../src/images/Thanshiq/diamond mainpage/CityLocation/main/icons8-arrow-50.png"
import karate from "../../src/images/Thanshiq/karate.webp"
import metaD from "../../src/images/Thanshiq/diamond mainpage/pd-metal.svg"
import General from "../../src/images/Thanshiq/diamond mainpage/pd-general.svg"
import DiamonDetails from "../../src/images/Thanshiq/diamond mainpage/pd-diamond.svg"
import Descri from "../../src/images/Thanshiq/diamond mainpage/pd-description.svg"
import { Accordion, Button, ModalBody, Table } from "react-bootstrap";
import pd1 from "../../src/images/Thanshiq/diamond mainpage/ProductD1.webp"
import pd2 from "../../src/images/Thanshiq/diamond mainpage/ProductD2.webp"
import pd3 from "../../src/images/Thanshiq/diamond mainpage/ProductD3.webp"
import pd4 from "../../src/images/Thanshiq/diamond mainpage/ProductD4.webp"
import pd5 from "../../src/images/Thanshiq/diamond mainpage/ProductD6.webp"
import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image';
import Col from 'react-bootstrap/Col';
import grmsimg from "../../src/images/Thanshiq/grms.webp"
import { SortAscIcon } from "lucide-react";
import { Modal } from "react-bootstrap";
import copyIcon from "../images/Thanshiq/copy-icon.webp"
import ZoomableImage from "./ZoomableImage";
import { getPageProductType } from "api/ProductTypeApi";
import { getAllProductCate } from "api/ProductCategoryApi";
import { createEnquiry, EmplyeeId, EnquierySource, EnquieryStatus, EnquieryTypeId, Language } from "api/BookAnAppointmentApi";

const StyledDiv = tw.div`font-display overflow-hidden md:overflow-visible `;

const AccordionButton = styled.button`
  background-color: #eee;
  color: #444;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  text-align: left;
  border: none;
  outline: none;
  transition: background-color 0.4s;

  &:hover {
    background-color: #ccc;
  }

  &.active {
    background-color: #ccc;
  }
`;


const Panel = styled.div`
  padding: 0 18px;
  background-color: white;
  display: ${(props) => (props.active ? "block" : "none")};
  overflow: hidden;
  transition: max-height 0.2s ease-out;
`;

export default ({ configImages }) => {
  const [Details, setDetails] = useState([]);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [openCustomizationKey, setOpenCustomizationKey] = useState("metal");
  const [scheduleDate, setScheduleDate] = useState(
      moment().add(1, "hours").format("YYYY-MM-DDTHH:mm")
    );
  const [EnquieryStatusId, setEnquieryStatusId] = useState("");
  const [EnquieryTypeid, setEnquieryTypeid] = useState("");
  const [currentlang, setCurrentlang] = useState([]);
  const [EmployeeId, setEmployeeId] = useState("");
  const [EnquieryId, setEnquieryId] = useState("");
  const [otherCharge, setOtherCharge] = useState([]);
  const [productType, setProductType] = useState([]);
  const [productCategory, setCategoryList] = useState([]);
  const [selectedGrams, setSelectedGrams] = useState("");
  const [selectedMetal, setSelectedMetal] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedGender, setSelectedGender] = useState("");
  const [productId, setProductId] = useState("");
  const [additionalCharge, setAdditionalCharge] = useState([]);
  const [isLoader, setLoader] = useState(false);
  const [Img, setImg] = useState([]);
  const [Spec, setSpec] = useState([]);
  const [LikeCount, setLikeCount] = useState("");
  const [WishCount, setWishCount] = useState("");
  const [banner, setBanner] = useState([]);
  const [currentImg, setCurrentImg] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [isActiveToggle, setIsActiveToggle] = useState(false);
  const [secMetalDetail, setSecMetalDetail] = useState([]);
  const [branch, setBranch] = useState({});
  const [isShow, setIsShow] = useState(false);
  const [wishState, setWishState] = useState({});
  const [categoryItem, setCategoryItem] = useState({});



  // const [branchName, setBranchName ] = useState("");
  // const history = useNavigate();
  const isMetalSelected = !!selectedMetal;
  const location = useLocation();
  const navigate = useNavigate();

  const { dispatch } = useCartContext();

  const handleButtonClick = () => {
    navigate('/NewArrivals');
  };

  const genderImages = [
    {
      title: "MALE",

      gender: "M",
    },
    {
      title: "FEMALE",

      gender: "F",
    },
    // {
    //   title: "COUPLE",

    //   gender: "C",
    // },
    {
      title: "BABY",

      gender: "K",
    },
    {
      title: "UNISEX",

      gender: "U",
    },
  ]

  useEffect(() => {
    // getProductIdParsing();
     Promise.all([
      getBanner(),
      getBrachDataList(),
      getProductType(),
      EnquierySourceId(),
      EnquierySourceStatus(),
      EnquieryEmployeeId(),
      EnquieryType(),
      Selectlanguage(),
      // getCategoryList(),
    ])
    return () => { };
    //eslint-disable-next-line
  }, []);

  const getBrachDataList = () => {
    branchdetails(getBranchId()).then((data) => {
      setBranch(data.response);
    });
  };

  useEffect(() => {
    getProductIdParsing();
    getAddToCartDetails();
    //eslint-disable-next-line
  }, [location.state]);

  useEffect(() => {
  if (selectedMetal === "Gold") {
    const data = getGoldProductCustomizationData();
    setCategoryItem(data);
  } else if (selectedMetal === "Silver") {
    const silverInfo = getSilverProductCustomizationData();
    setCategoryItem(silverInfo)
  }
}, [selectedMetal]);

  const getProductIdParsing = () => {
    let productId = "";
    if (!location.state) {
      const pathName = location.pathname.split("/");
      productId = pathName[2];
    } else {
      productId = location.state?.categoryItem?.id;
    }
    setProductId(productId);
    getRateApi(productId);
    likeCountDetails(productId);
    wishCountDetails(productId);
  };

  const getProductType = async () => {
  await getPageProductType({ active: 1 }).then((data) => {
    const response = data.response.content || [];
    const pList = response
      .filter((item) => {
        const hasMetaCategory = item.metaProductCategoryList.length > 0 && item.id;
        const name = (item.name || "").toLowerCase();
        const isGoldOrSilver = name.includes("gold") || name.includes("silver") && !name.includes('articles');
        return hasMetaCategory && isGoldOrSilver;
      })
      .reverse(); 

    setProductType(pList);
  });
};


  const getCategoryList = async () => {
      let visibilityList = [];
      let filterData = {
        metaProdTypeEnty: selectedMetal ? selectedMetal : "",
        // visibilityMode: "WEB_MOBILE,MOBILE",
      };
      if (filterData.metaProdTypeEnty === "") {
        delete filterData.metaProdTypeEnty;
      }
      await getAllProductCate(filterData).then((data) => {
        const productResponse = data.response;
        visibilityList = productResponse.filter(
          (item) =>
            item.visibilityMode === "WEB_MOBILE" ||
            item.visibilityMode === "MOBILE"
        );
        setCategoryList(visibilityList);
      });
    };

  const getBanner = () => {
    configImages &&
      configImages.E_COMMERCE_BANNERS.forEach((data) => {
        if (data.key === "productDetails") {
          setBanner(data?.value);
        }
      });
  };

  const safeParseJSON = (str, fallback = []) => {
    try {
      if (typeof str !== "string" || str.trim() === "") return fallback;
      return JSON.parse(str);
    } catch (e) {
      return fallback;
    }
  };

  const closeModal = () => {
    setShowModal(false);
  }

  const getRateApi = async (productId) => {
    let allOtherCharges = [];
    let stoneChargeList = [];
    let secMetalDetails = [];
    let currentDate = moment().format(YEAR_WISE_FORMAT);

    let filter = {
      branch: getBranchId(),
      beforeCreatedAt: filterFormatToDate(currentDate),
      id: productId,
    };

    dispatch({ type: "DAYCLOSED", payload: filterFormatToDate(currentDate) });

    await getProduct(10, filter).then((data) => {
      let imageData = [];
      const productResponse = data.response.content[0];
      const imageResponse = data.response.content[0];

      // Handle image logic
      if (imageResponse && imageResponse !== "" && imageResponse !== "-") {
        const img = imageResponse?.images ?? "";
        let productImg = img.split("@#@").filter((item) => item !== "");
        setImg(productImg);
        setCurrentImg(productImg);
      } else {
        imageData.push({ image: currentImg });
        setImg(imageData);
        setCurrentImg(currentImg);
      }

      // Set specs
      setSpec(data.response.prodSpecMappingList ?? "");

      // Parse JSON safely
      let otherChargeJSON = safeParseJSON(productResponse?.otherCharges);
      let secMetalJSON = safeParseJSON(productResponse?.secMetalDetails);
      let weight = safeParseJSON(productResponse?.weight);
      let parsedOtherCharges = safeParseJSON(productResponse?.otherCharges);

      // Set secondary metal details
      secMetalJSON.forEach((item) => {
        secMetalDetails.push(item);
      });

      // Filter specific charges
      allOtherCharges = otherChargeJSON.filter((item) =>
        ["stonecharge", "handlingcharge", "stampingcharge", "additionalcharge", "freightCharges"].includes(item.remarks)
      );
      setAdditionalCharge(allOtherCharges);

      // Set stone charges
      otherChargeJSON.forEach((item) => {
        if (item?.stone?.length > 0) {
          stoneChargeList = item.stone;
        }
      });

      // Extract certificate number
      let Certificate = "";
      parsedOtherCharges.forEach((value) => {
        if (value.stone && value.stone.length > 0) {
          Certificate = value.stone[0].certificatenumber;
        }
      });

      const Rate = productResponse ?? "";

      // Set final product details
      setDetails({
        ...productResponse,
        ...Rate,
        Certificate,
        weight,
      });

      setLoader(true);
      setOtherCharge(stoneChargeList);
      setSecMetalDetail(secMetalDetails);
    });
  };

  useEffect(() =>{
    if(Details?.category?.includes('VEL')){
      setSelectedTab("customization")
    }
  }, [Details])

   const buynow = () => {
    if (getCustomerId()) {
      navigate("/CheckoutPage", { state: { Details, prdctId: Details.id , isBuyNow: 'buyNow' } });
    } else {
      dispatch({ type: "MODAL", payload: "login" });
    }
  }

  const likeCountDetails = async (countId) => {
    try {
      const data = await likeCount(countId);
      const likeData = data.response;
      setLikeCount(likeData > 0 ? likeData : 0);
    } catch (error) {
      console.error("Error fetching like count:", error);
      setLikeCount(0);
    }
  };

  const wishCountDetails = async (countId) => {
    try {
      const data = await wishCount(countId);
      const wishData = data.response;
      setWishCount(wishData > 0 ? wishData : 0);
    } catch (error) {
      console.error("Error fetching wish count:", error);
      setWishCount(0);
    }
  };

  const wishCountFunc = (product) => {
    if (getCustomerId() && getCustomerId() !== "onlinepayment") {
      const productId = product.productId ? product.productId : product.id;
      setWishState((prevState) => ({
        ...prevState,
        [productId]: !prevState[productId],
      }));

      if (wishState[productId]) {
        const deletWish = `customerId=${getCustomerId()}&productId=${productId}`;
        deleteCustomerWish(deletWish);
      } else {
        const createWish = `customerId=${getCustomerId()}&productId=${productId}&remark=liked`;
        createCustomerWish(createWish);
      }
    } else {
      dispatch({ type: "MODAL", payload: "login" });
    }
  };

  const EnquierySourceId = () => {
    EnquierySource().then((data) => {
      if (data.response.length > 0 && data) {
        let enquiryName = data.response;
        // filter(
        //   (item) => item.name && item.name.toLowerCase() === "web"
        // );
        let selectedEnquirySource = enquiryName.filter(item => item.name === 'ECOMM_WEB' || 'YOUTUBE')
          // enquiryName.length > 0 ? enquiryName[9].id : "";
        setEnquieryId(selectedEnquirySource);
      }
    });
  };

  const EnquierySourceStatus = () => {
      EnquieryStatus().then((data) => {
        if (data.response.length > 0 && data) {
          let enquiryId = data.response.filter(
            (item) => item.name && item.name.toLowerCase() === "hot"
          );
          let selectedEnquiryId = enquiryId.length > 0 ? enquiryId[0].id : "";
          setEnquieryStatusId(selectedEnquiryId);
        }
      });
    };

    const EnquieryEmployeeId = () => {
    const employee = {
      name: "ONLINEPAYMENT",
    };
    EmplyeeId(JSON.stringify(employee)).then((data) => {
      if (data.response.length > 0 && data) {
        let enquiryName = data.response;
        let selectedEnquirySource =
          enquiryName.length > 0 ? enquiryName[0].id : "";
        setEmployeeId(selectedEnquirySource);
      }
    });
  };

   const EnquieryType = () => {
      EnquieryTypeId().then((data) => {
        if (data.response.length > 0 && data) {
          let enquiryTypeId = data.response.filter(
            (item) => item.name && item.name.toLowerCase() === "sales"
          );
          let selectedEnquiryTypeId =
            enquiryTypeId.length > 0 ? enquiryTypeId[0].id : "";
          setEnquieryTypeid(selectedEnquiryTypeId);
        }
      });
    };

    const Selectlanguage = async() => {
        let languageList = [];
        const languageResData = await Language();
        if(languageResData.response && languageResData.response.length > 0){
          languageResData.response.forEach((item) => {
            const data = {
              value: item.id,
              title: item.languageName,
              selected: false,
            };
            languageList.push(data);
          });
        };
        let defValue = languageList.filter(language => language.title.toLowerCase() === "tamil");
        setCurrentlang(defValue);
      };

  const getGoldProductCustomizationData = () => {
    const customizationData = [
  {
    "name": "916 HOLLOW RING ",
    "gender":["UNISEX"],
    "data": [
      { "size": 10, "grams": [2, 3, 4] },
      { "size": 11, "grams": [2, 3, 4] },
      { "size": 12, "grams": [2, 3, 4] },
      { "size": 13, "grams": [2, 3, 4] },
      { "size": 14, "grams": [2, 3, 4] },
      { "size": 15, "grams": [2, 3, 4] },
      { "size": 16, "grams": [2, 3, 4] },
      { "size": 17, "grams": [2, 3, 4] },
      { "size": 18, "grams": [2, 3, 4] },
      { "size": 19, "grams": [2, 3, 4] },
      { "size": 20, "grams": [2, 3, 4] }
    ]
  },
  {
    "name": "916 GETTI RING",
    "gender":["MALE"],
    "data": [
      { "size": 21, "grams": [6, 8, 12, 16, 20, 24] },
      { "size": 22, "grams": [6, 8, 12, 16, 20, 24] },
      { "size": 23, "grams": [6, 8, 12, 16, 20, 24] },
      { "size": 24, "grams": [6, 8, 12, 16, 20, 24] },
      { "size": 25, "grams": [6, 8, 12, 16, 20, 24] },
      { "size": 26, "grams": [6, 8, 12, 16, 20, 24] },
      { "size": 27, "grams": [6, 8, 12, 16, 20, 24] },
      { "size": 28, "grams": [6, 8, 12, 16, 20, 24] },
      { "size": 29, "grams": [6, 8, 12, 16, 20, 24] },
      { "size": 30, "grams": [6, 8, 12, 16, 20, 24] }
    ]
  },

  {
    "name": "916 PENDANTS",
    "data": [
      { "inches": "<1\" WITH BOW HOOK", "grams": 1.5 },
      { "inches": "1\" WITH BOW HOOK", "grams": 2.5 },
      { "inches": "1.25\" WITH BOW HOOK", "grams": 4 },
      { "inches": "1.5\" WITH BOW HOOK", "grams": 6 },
      { "inches": "2\" TO 2.5\" WITH BOW HOOK", "grams": 8 }
    ]
  },
    {
    "name": "916 POOJAI VEL",
    "data": [
      { "inches": "2.75\"", "grams": 6 },
      { "inches": "5\"", "grams": 20 },
      { "inches": "7\"", "grams": 40 },
      { "inches": "9\"", "grams": 56 },
      { "inches": "12\"", "grams": 80 }
    ]
  },
  {
    "name": "HOLLOW PIPE ROUND KADA BANGLE ",
      "gender":["MALE"],
    "data": [
      { "size": "1.10.16", "grams": 4 },
      { "size": "1.12.16", "grams": 4 },
      { "size": "1.14.16", "grams": 4 },
      { "size": "2", "grams": 4 }
    ]
  },
  {
    "name": "HOLLOW PIPE ROUND KADA",
         "gender":["LADIES","BOYS","GIRLS"],
    "data": [
      { "size": "2.2", "grams": 8 },
      { "size": "2.4", "grams": 10 },
      { "size": "2.6", "grams": 10 },
      { "size": "2.8", "grams": 12 }
    ]
  },
  {
    "name": "GETTI PIPE ROUND KADA",
      "gender":["LADIES","BOYS","GIRLS"],
    "data": [
      { "size": "2.2", "grams": 20 },
      { "size": "2.4", "grams": 24 },
      { "size": "2.6", "grams": 28 },
      { "size": "2.8", "grams": 32 }
    ]
  },
  {
    "name": "GETTI PIPE ROUND KADA",
      "gender":["MALE"],
    "data": [
      { "size": "2.1", "grams": 40 },
      { "size": "2.12", "grams": 48 },
      { "size": "2.14", "grams": 56 },
      { "size": "3", "grams": 80 }
    ]
  }
    ]
    return customizationData;
  }

  const getSilverProductCustomizationData = () => {
    const silverCustomization = [
  {
    "name": "925 HOLLOW RING",
    "gender":["UNISEX"],
    "data": [
      { "size": 10, "grams": [3, 4, 5] },
      { "size": 11, "grams": [3, 4, 5] },
      { "size": 12, "grams": [3, 4, 5] },
      { "size": 13, "grams": [3, 4, 5] },
      { "size": 14, "grams": [3, 4, 5] },
      { "size": 15, "grams": [3, 4, 5] },
      { "size": 16, "grams": [3, 4, 5] },
      { "size": 17, "grams": [3, 4, 5] },
      { "size": 18, "grams": [3, 4, 5] },
      { "size": 19, "grams": [3, 4, 5] },
      { "size": 20, "grams": [3, 4, 5] }
    ]
  },
  {
    "name": "916 GETTI RING",
    "gender":["MALE"],
    "data": [
      { "size": 21, "grams": [10,11,12,13,14,15,16,17,18,19,20] },
      { "size": 22, "grams": [10,11,12,13,14,15,16,17,18,19,20] },
      { "size": 23, "grams": [10,11,12,13,14,15,16,17,18,19,20] },
      { "size": 24, "grams": [10,11,12,13,14,15,16,17,18,19,20] },
      { "size": 25, "grams": [10,11,12,13,14,15,16,17,18,19,20] },
      { "size": 26, "grams": [10,11,12,13,14,15,16,17,18,19,20] },
      { "size": 27, "grams": [10,11,12,13,14,15,16,17,18,19,20] },
      { "size": 28, "grams": [10,11,12,13,14,15,16,17,18,19,20] },
      { "size": 29, "grams": [10,11,12,13,14,15,16,17,18,19,20] },
      { "size": 30, "grams": [10,11,12,13,14,15,16,17,18,19,20] }
    ]
  },
  {
    "name": "916 POOJAI VEL",
    "data": [
      { "inches": "2.75\"", "grams": 6 },
      { "inches": "5\"", "grams": 20 }
    ]
  },
  {
    "name": "925 PENDANTS",
    "gender":["UNISEX"],
    "data": [
      { "inches": "<1\" WITH BOW HOOK", "grams": 2 },
      { "inches": "1\" WITH BOW HOOK", "grams": 4 },
      { "inches": "1.25\" WITH BOW HOOK", "grams": 5 },
      { "inches": "1.5\" WITH BOW HOOK", "grams": 6 },
      { "inches": "2\" TO 2.5\" WITH BOW HOOK", "grams": 8 }
    ]
  },
  {
    "name": "925 HOLLOW PIPE ROUND KADA BANGLE FOR BABY",
    "data": [
      { "size": "1.10.16", "grams": [4, 6, 8] }
    ]
  },
  {
    "name": "925 HOLLOW PIPE ROUND KADA",
    "gender":["LADIES","BOYS","GIRLS"],
    "data": [
      { "size": "2.2", "grams": 20 },
      { "size": "2.4", "grams": 20 },
      { "size": "2.6", "grams": 20 },
      { "size": "2.8", "grams": 20 }
    ]
  },
  {
    "name": "925 GETTI PIPE ROUND KADA",
    "gender":["MALE"],
    "data": [
      { "size": "2.1", "grams": 50 },
      { "size": "2.12", "grams": 50 },
      { "size": "2.14", "grams": 50 },
      { "size": "3", "grams": 50 }
    ]
  }
]
  return silverCustomization;
  }

  const createCustomerEnquiry = () => {
    const demoEndDate = moment(scheduleDate, "YYYY-MM-DDThh:mm")
      .add(20, "minutes")
      .format("DD-MM-YYYY hh:mm A");
    const newDemoStartDate = moment(scheduleDate, "YYYY-MM-DDThh:mm").format(
      "YYYY-MM-DD HH:mm:ss"
    );
    const newDemoEndDate = moment(demoEndDate, "DD-MM-YYYY hh:mm A").format(
      "YYYY-MM-DD HH:mm:ss"
    );
    const newPreviousFollowUpDate = currentDateToUtcDate(newDemoStartDate);
    const newNextFollowupDate = currentDateToUtcDate(newDemoEndDate);
    const currentDateAndTime = currentRegister();
    const newCurrentDate = currentDateToUtcDate(currentDateAndTime);
    const customerEmail = getCustomerMail()
    const customerData = {};
    customerData.id = getCustomerId();
    customerData.name = getCustomerName()
    customerData.branchId = getBranchId();
    customerData.email = customerEmail
    customerData.enquirySource = "WEB";
    customerData.crmStatus = "ENGAGING";
    customerData.enrollmentDate = newCurrentDate;
    customerData.customerAddress = getCustomerAddress()
    customerData.countryCode = "+91";
    customerData.customerType = "CUSTOMER";
    customerData.homeCountry = "LOCAL";
      let enquiryInfo = `Metal:${selectedMetal},Category:${selectedCategory},Gender:${selectedGender ? selectedGender : 'Not Mentioned'},Grams:${selectedGrams},Size:${selectedSize}`
      const reqInfo = `Custom Order: ${enquiryInfo}`
    let productId = Details.id ? Details.id : null;

    const enquiryData = {
          customer: customerData,
          enquirySourceId: EnquieryId[0]?.id ?? null,
          enquiryStatusId: EnquieryStatusId,
          enqGeneratedById: EmployeeId,
          productId: productId,
          prevFollowUpDate: newPreviousFollowUpDate,
          nextFollowUpDate: newNextFollowupDate,
          enquiryTypeId: EnquieryTypeid,
          reqDetails: reqInfo,
          branchId: getBranchId(),
          languageId: currentlang.value !== null ? currentlang.value : null,
          metalTypeid: selectedMetal.id !== null ? selectedMetal.id : null,
        };
    createEnquiry(JSON.stringify(enquiryData))
    .then((data) => {
      console.log('enquiry created successfully');
    })
    .catch((err) => {
      console.error(`not created because of ${err}`)
    })
  }

  const addToCart = (productCode) => {
    if (!getCustomerId()) {
    dispatch({ type: "MODAL", payload: "login" });
    return;
  }
    const productData = JSON.parse(
      getAddToCart() !== undefined ? getAddToCart() : "[]"
    );
    let products = [];
    products = productData;
    if (products.length < 3 && products.length !== 3) {
      products.push(Details);
      let storeCardItem = JSON.parse(
        getAddToCart() !== undefined ? getAddToCart() : "[]"
      );
      const validateProduct = storeCardItem.some(
        (item) => item.productCode === productCode
      );

      if (!validateProduct) {
        setAddToCart(JSON.stringify(products));
        if (selectedMetal !== '' && selectedCategory !== '' && selectedSize !== '' && selectedGrams !== '') {
          createCustomerEnquiry()
        }
        // setTimeout(() => {
        dispatch({ type: "ADD", payload: JSON.parse(getAddToCart()) });
        // }, 0);
        toast.success("Product Added To The Cart", {
          duration: 2000,
          position: "top-right",
        });
      } else {
        toast.error("Product Already Added To The Cart !", {
          duration: 3000,
          position: "top-right",
        });
      }
    } else {
      toast.error(
        "Cart Limit Reached Your Cart Can Only Contain Up To Three Items !",
        {
          duration: 3000,
          position: "top-right",
        }
      );
    }
  };

  // const buynow = (productCode) => {
  //   const productData = JSON.parse(
  //     getAddToCart() !== undefined ? getAddToCart() : "[]"
  //   );
  //   let products = [];
  //   products = productData;
  //   if (products.length < 3 && products.length !== 3) {
  //     products.push(Details);
  //     let storeCardItem = JSON.parse(
  //       getAddToCart() !== undefined ? getAddToCart() : "[]"
  //     );
  //     const validateProduct = storeCardItem.some(
  //       (item) => item.productCode === productCode
  //     );
  //     if (!validateProduct) {
  //       if (getCustomerId()) {
  //         setAddToCart(JSON.stringify(products));
  //         dispatch({ type: "ADD", payload: JSON.parse(getAddToCart()) });
  //         navigate("/CheckoutPage", { state: { Details } });
  //       } else {
  //         dispatch({ type: "MODAL", payload: "login" });
  //       }
  //     } else {
  //       if (getCustomerId()) {
  //         navigate("/CheckoutPage", { state: { Details } });
  //       } else {
  //         dispatch({ type: "MODAL", payload: "login" });
  //       }
  //     }
  //   } else {
  //     toast.error(
  //       "Cart Limit Reached Your Cart Can Only Contain Up To Three Items !",
  //       {
  //         duration: 3000,
  //         position: "top-right",
  //       }
  //     );
  //   }
  // };

  const thumb = (index) => {
    setCurrentImg(Img[index]);
  };

  const toggleAccordion = () => {
    setIsActive(!isActive);
  };

  const toggleAccordionToggle = () => {
    setIsActiveToggle(!isActiveToggle);
  };

  const getAddToCartDetails = async () => {
    let filter = "savings_scheme_app";
    ECommerce(filter).then((data) => {
      let showButton = JSON.parse(data.response.moduleField);
      let isShowData = showButton.filter(
        (item) => item.key === "IS_ECOMM_ADD_TO_CART_ENABLED"
      );
      setIsShow(isShowData[0]?.value);
    });
  };

  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState({});
  useEffect(() => {
    fetch(
      "https://valid.layercode.workers.dev/list/countries?format=select&flags=true&value=code"
    )
      .then((response) => response.json())
      .then((data) => {
        setCountries(data.countries);
        setSelectedCountry(data.userSelectValue);
      });
  }, []);
  const customStyles = {
    control: (provided) => ({
      ...provided,
      width: 400,
      padding: 10,
    }),
  };
  const [open, setOpen] = useState(false);

  const toggleCollapse = () => {
    setOpen(!open);
  };
  const [type, setType] = useState(false);

  const hadleTypeClick = () => {
    setType(!type);
  };
  const [generalDe, setGeneralDe] = useState();

  const handleGeneralClick = () => {
    setType(!generalDe);
  };
  const [description, setDescription] = useState();

  const handleDescriptionClick = () => {
    setType(!description);
  };
  const metalDetails = [{
    MetalType: "karat",
    Many: "22K",
    colors: "Material Colour",
    color: "Yellow",
    Weight: "Gross Weight",
    HowWaight: "5.24lg",
  },
  ]
  const Assurance = [
    { img: a1, title: "100% Exchange Value on Precious Stones" },
    { img: a2, title: "The Purity Guarantee" },
    { img: a3, title: "Complete Transparency and Trust" },
    { img: a4, title: "Lifetime Maintenance" },

  ]
  const textStyle = {
    fontFamily: '"Exo", sans-serif',
    fontOpticalSizing: 'auto',
    fontWeight: '<weight>',
    fontStyle: 'normal',
  };
  const [selectedTab, setSelectedTab] = useState("product");
  const [showModal, setShowModal] = useState(false);
  const toPascalCase = (text) => {
    if (!text) return '';

    return text
      .toLowerCase()
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };
  const [showCopyLink, setShowCopyLink] = useState(false);
  const [copiedLink, setCopiedLink] = useState(false);
  const copyLink = () => {
    const currentPath = window.location.href;
    const link = currentPath;
    // const encodedLink = encodeURIComponent(currentPath);
    navigator.clipboard.writeText(link).then(() => {
      setCopiedLink(link);
      setShowCopyLink(false);
      toast.success('Link copied!');
      navigate(`/ProductDetails/${productId}`);
    });
  };

  const showImageModal = () => {
    setShowModal(true);
  }
 return (
  <StyledDiv>
    <Toaster position="top-right" />
    
    {/* Breadcrumb Navigation */}
    <div className="px-sm-5 px-3" style={{ paddingTop: "1rem", fontSize: "0.9rem" }}>
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb m-0">
          <li className="breadcrumb-item">
            <Link to="/" className="text-decoration-none text-secondary">
              Home
            </Link>
          </li>
          <li className="breadcrumb-item active text-custom-100" aria-current="page">
            {Details.productName?.toLowerCase()}
          </li>
        </ol>
      </nav>
    </div>

    {/* Main Product Section */}
    <div className="container my-4">
      <div className="row g-4">
        
        {/* Left Column - Product Images */}
        <div className="col-lg-6 col-md-6">
          <div className="card border-0 shadow-sm rounded-3 overflow-hidden">
            <div className="position-relative">
              <span onClick={showImageModal} style={{ cursor: "zoom-in" }}>
                <ZoomableImage 
                  src={currentImg} 
                  style={{ width: "100%", height: "auto" }}
                />
              </span>
              
              {/* Wishlist and Share Buttons */}
              <div className="position-absolute top-0 end-0 p-3 d-flex gap-2">
                <button
                  type="button"
                  className={`btn btn-light btn-sm rounded-circle shadow-sm ${
                    wishState[categoryItem.id] ? "text-danger" : "text-secondary"
                  }`}
                  onClick={() => wishCountFunc(categoryItem)}
                  style={{
                    width: "40px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                  title="Add to Wishlist"
                >
                  <i className={`bi bi-heart${wishState[categoryItem.id] ? "-fill" : ""}`}></i>
                  {categoryItem.wishListCount > 0 && (
                    <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                      {categoryItem.wishListCount}
                    </span>
                  )}
                </button>
                
                <button
                  type="button"
                  className="btn btn-light btn-sm rounded-circle shadow-sm"
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop"
                  style={{
                    width: "40px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                  title="Share"
                >
                  <i className="bi bi-share text-secondary"></i>
                </button>
              </div>
            </div>
            
            {/* Thumbnail Images */}
            <div className="p-3 bg-light">
              <div className="d-flex flex-wrap gap-2 justify-content-start">
                {Img.map((image, index) => (
                  <div
                    key={index}
                    className={`thumbnail-wrapper ${currentImg === image ? "active" : ""}`}
                    onClick={() => setCurrentImg(image)}
                    style={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "8px",
                      overflow: "hidden",
                      cursor: "pointer",
                      border: currentImg === image ? "2px solid #811331" : "2px solid transparent",
                      padding: "2px"
                    }}
                  >
                    <img
                      src={image}
                      alt={`Thumbnail ${index + 1}`}
                      className="img-fluid h-100 w-100"
                      style={{ objectFit: "cover" }}
                    />
                  </div>
                ))}
              </div>
            </div>
            
            {/* Product Specifications */}
            <div className="p-3 border-top">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="d-flex align-items-center gap-3">
                  <div className="spec-item d-flex align-items-center gap-2">
                    <img src={karate} alt="Karat" style={{ width: "24px", height: "24px" }} />
                    <span style={{ color: "#832729", fontWeight: "500" }}>
                      {Details.weight?.purity || "22 Karat"}
                    </span>
                  </div>
                  <div className="spec-item d-flex align-items-center gap-2">
                    <img src={grmsimg} alt="Weight" style={{ width: "24px", height: "24px" }} />
                    <span style={{ color: "#832729", fontWeight: "500" }}>
                      {Details.weight?.netWeight || "0"} gm
                    </span>
                  </div>
                </div>
                
                {/* {Details.hallmarked && (
                  <div className="badge bg-warning text-dark p-2">
                    <i className="bi bi-shield-check me-1"></i>
                    {Details.hallmarked}
                  </div>
                )} */}
              </div>
              
              {/* WhatsApp Button */}
              <div className="d-grid">
                <button
                  type="button"
                  className="btn btn-success d-flex align-items-center justify-content-center gap-2 py-2"
                  style={{
                    borderRadius: "25px",
                    background: "linear-gradient(135deg, rgba(70, 46, 46, 0.86) 0%,rgba(240, 105, 179, 0.66) 100%)",
                    border: "none",
                    fontWeight: "600",
                    transition: "all 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.02)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                >
                  <i className="bi bi-whatsapp fs-5"></i>
                  <span>Click For Further Discussion</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - Product Details */}
        <div className="col-lg-6 col-md-6">
          <div className="card border-0 shadow-sm rounded-3 h-100">
            <div className="card-body py-0">
              {/* Product Title and Code */}
              <div className="mb-4">
                <h1 className="h2 fw-bold text-dark mb-2">
                  {Details.productName || "Product Name"}
                </h1>
                <div className="d-flex align-items-center gap-3">
                  <span className="badge bg-light text-dark border">
                    Code: <strong>{Details.productCode}</strong>
                  </span>
                  <span className={`badge ${Details.stockStatus === 'Sale' ? 'bg-success' : 'bg-warning'}`}>
                    {Details.stockStatus}
                  </span>
                </div>
              </div>

              {/* Price Display */}
              {Number.isFinite(Details?.total) && (
                <div className="mb-4">
                  <div className="d-flex align-items-baseline gap-2">
                    <span className="text-muted" style={{ fontSize: "0.9rem" }}>Total Price</span>
                    <h2 className="text-dark fw-bold mb-0">
                      ₹ {Math.trunc(Details.total).toLocaleString('en-IN')}
                    </h2>
                  </div>
                  <small className="text-muted d-block">
                    <i className="bi bi-info-circle me-1"></i>
                    Inclusive of all taxes and charges
                  </small>
                  
                  {/* Price Per Gram */}
                  {/* {Details.weight?.grossWeight && Details.total && (
                    <div className="mt-2">
                      <span className="text-success fw-medium">
                        ≈ ₹ {(Details.total / Details.weight.grossWeight).toFixed(2)} per gram
                      </span>
                    </div>
                  )} */}
                 </div>
               )}

               {/* Action Buttons */}
               <div className="mb-4 d-flex flex-wrap gap-3">
                <button
                  className="btn d-flex align-items-center justify-content-center gap-2 px-4 py-2 btn-outline-primary"
                  style={{
                    minWidth: "250px",
                    borderRadius: "25px",
                    fontWeight: "600",
                  }}
                  onClick={() => navigate("/BookAnAppointment")}
                >
                  <img
                    src={tryit}
                    style={{ height: "20px", width: "auto", color: '#811331'}}
                    alt="Try It On"
                  />
                  <span>Book An Appointment</span>
                </button>
                
                <button
                  className="btn d-flex btn-outline-primary align-items-center justify-content-center gap-2 px-4 py-2"
                  style={{ borderRadius: "25px", fontWeight: "600" }}
                  onClick={() => addToCart(Details.productCode)}
                >
                  <i className="bi bi-cart-plus"></i>
                  <span>Add to Cart</span>
                </button>
                <button
                  className="btn d-flex btn-outline-primary align-items-center justify-content-center gap-2 px-4 py-2"
                  style={{ borderRadius: "25px", fontWeight: "600" }}
                  onClick={() =>  buynow()}
                >
                  <i className="bi bi-bag-heart"></i>
                  <span>Buy Now</span>
                </button>
              </div>
               {/* <div
                 className="sticky-footer"
                 style={{
                   width: "330px" ,
                   border: "1px solid #832729",
                 }}
               >
                 <div style={{ marginRight: "20px" }}>
                   {" "}
                   Price: ₹{Math.trunc(Details.total || "-").toLocaleString('en-IN')}{" "}
                 </div>
                 <div style={{ marginRight: "20px" }}>
                   {" "}
                   {Details?.weight?.netWeight || "-"}{" "}
                 </div>
                 <button
                   onClick={() => {
                     addToCart(Details.productCode);
                   }}
                   className="btn p-2 pr-2"
                   id="btn"
                 >
                   Add to Cart
                 </button>
                  <button
                   onClick={() => {
                     buynow();
                   }}
                   className="btn p-2"
                   id="btn"
                 >
                   Buy Now
                 </button>
               </div> */}

               {/* Delivery Information */}
               {/* <div className="alert alert-light border mb-4">
                <div className="d-flex align-items-start gap-3">
                  <i className="bi bi-truck text-primary fs-4"></i>
                  <div>
                    <h6 className="fw-bold mb-1">Delivery Information</h6>
                    <p className="text-muted mb-1">
                      <i className="bi bi-check-circle-fill text-success me-1"></i>
                      Available for demo
                    </p>
                    <p className="text-muted mb-0">
                      <i className="bi bi-clock text-warning me-1"></i>
                      Delivery days: {Details.deliveryDays || "To be confirmed"}
                    </p>
                  </div>
                </div>
              </div> */}

              {/* Details Tabs */}
              <div className="mb-4">
                <ul className="nav nav-tabs" id="productDetailsTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${selectedTab === "product" ? "active" : ""}`}
                      id="product-tab"
                      onClick={() => setSelectedTab("product")}
                      style={{
                        color: selectedTab === "product" ? "#811331" : "#6c757d",
                        fontWeight: "500"
                      }}
                    >
                      Product Details
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${selectedTab === "price" ? "active" : ""}`}
                      id="price-tab"
                      onClick={() => setSelectedTab("price")}
                      style={{
                        color: selectedTab === "price" ? "#811331" : "#6c757d",
                        fontWeight: "500"
                      }}
                    >
                      Price Breakup
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${selectedTab === "customization" ? "active" : ""}`}
                      id="customization-tab"
                      onClick={() => setSelectedTab("customization")}
                      style={{
                        color: selectedTab === "customization" ? "#811331" : "#6c757d",
                        fontWeight: "500"
                      }}
                    >
                      Customization
                    </button>
                  </li>
                </ul>

                <div className="tab-content border border-top-0 rounded-bottom p-3">
                  {/* Product Details Tab */}
                  {selectedTab === "product" && (
                    <div className="tab-pane fade show active">
                      <Accordion defaultActiveKey="0">
                        {/* Metal Details */}
                        <Accordion.Item eventKey="0" className="border-0 mb-2">
                          <Accordion.Header className="bg-light rounded">
                            <div className="d-flex align-items-center gap-2">
                              <i className="bi bi-gem text-mgdm"></i>
                              <span className="fw-medium">METAL DETAILS</span>
                            </div>
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="row g-3">
                              <div className="col-md-4">
                                <div className="text-center p-2 bg-light rounded">
                                  <div className="text-muted small">Metal Type</div>
                                  <div className="fw-semibold">{Details.metalType || "-"}</div>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="text-center p-2 bg-light rounded">
                                  <div className="text-muted small">Wastage</div>
                                  <div className="fw-semibold">
                                    {Details.wastageValue ? `${Details.wastageValue}${Details.wastageType === "percentage" ? "%" : ""}` : "-"}
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="text-center p-2 bg-light rounded">
                                  <div className="text-muted small">Making Charges</div>
                                  <div className="fw-semibold">
                                    {Details.netMc ? `₹${Details.netMc.toLocaleString('en-IN')}` : "-"}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>

                        {/* Weight Details */}
                        <Accordion.Item eventKey="1" className="border-0">
                          <Accordion.Header className="bg-light rounded">
                            <div className="d-flex align-items-center gap-2">
                              <i className="bi bi-speedometer2 text-mgdm"></i>
                              <span className="fw-medium">WEIGHT DETAILS</span>
                            </div>
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="row g-3">
                              <div className="col-md-3">
                                <div className="text-center p-2 bg-light rounded">
                                  <div className="text-muted small">Gross Weight</div>
                                  <div className="fw-semibold">{Details.weight?.grossWeight || "-"} gm</div>
                                </div>
                              </div>
                               <div className="col-md-3">
                                <div className="text-center p-2 bg-light rounded">
                                  <div className="text-muted small">Less Weight</div>
                                  <div className="fw-semibold">{Details.weight?.lessWeight || "-"} gm</div>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="text-center p-2 bg-light rounded">
                                  <div className="text-muted small">Net Weight</div>
                                  <div className="fw-semibold">{Details.weight?.netWeight || "-"} gm</div>
                                </div>
                              </div>
                              {/* <div className="col-md-3">
                                <div className="text-center p-2 bg-light rounded">
                                  <div className="text-muted small">Pure Weight</div>
                                  <div className="fw-semibold">{Details.weight?.pureWeight || "-"} gm</div>
                                </div>
                              </div> */}
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  )}

                  {/* Price Breakup Tab */}
                  {selectedTab === "price" && (
                    <div className="tab-pane fade show active">
                      <div className="table-responsive">
                        <table className="table table-bordered mb-0">
                          <thead className="table-light">
                            <tr>
                              <th className="fw-semibold">COMPONENT</th>
                              <th className="fw-semibold text-end">AMOUNT (₹)</th>
                              <th className="fw-semibold">REMARKS</th>
                            </tr>
                          </thead>
                           <tbody>
                             {/* Gold Value */}
                             <tr>
                               <td>
                                 <div className="d-flex align-items-center gap-2">
                                   <i class="bi bi-coin icon-gold"></i>
                                   <span>Metal Value</span>
                                 </div>
                               </td>
                               <td className="text-end fw-semibold">
                                 {Details.basePrice ? `₹${Math.trunc(Details.weight?.netWeight * Details.todayRate).toLocaleString('en-IN')}` : "-"}
                               </td>
                              <td>
                                <small className="text-muted">
                                  {Details.weight?.netWeight || "-"} gm × ₹{Details.todayRate?.toLocaleString('en-IN') || "-"}/gm
                                </small>
                              </td>
                            </tr>

                            {/* Wastage Charges */}
                            <tr>
                              <td>
                                <div className="d-flex align-items-center gap-2">
                                  <i className="bi bi-plus-circle text-primary"></i>
                                  <span>Wastage Charges</span>
                                </div>
                              </td>
                              <td className="text-end fw-semibold">
                                {Details.wastageCost ? `₹${Math.trunc(Details.wastageCost).toLocaleString('en-IN')}` : "-"}
                              </td>
                              <td>
                                <small className="text-muted">
                                  {Details.wastageValue || "0"}% of gold value
                                </small>
                              </td>
                            </tr>

                            {/* Making Charges */}
                            {Details.makingCost > 0 && 
                            <tr>
                              <td>
                                <div className="d-flex align-items-center gap-2">
                                  <i className="bi bi-tools text-info"></i>
                                  <span>Making Charges</span>
                                </div>
                              </td>
                              <td className="text-end fw-semibold">
                                {Details.makingCost ? `₹${Math.trunc(Details.makingCost).toLocaleString('en-IN')}` : "-"}
                              </td>
                              <td>
                                <small className="text-muted">Craftsmanship charges</small>
                              </td>
                            </tr>
                            }

                            {/* Gemstone Cost */}
                            {Details.gemTotal > 0 && (
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center gap-2">
                                    <i className="bi bi-diamond text-success"></i>
                                    <span>Gemstone Cost</span>
                                  </div>
                                </td>
                                <td className="text-end fw-semibold">
                                  ₹{Math.trunc(Details.gemTotal).toLocaleString('en-IN')}
                                </td>
                                <td>
                                  <small className="text-muted">
                                    {Details.gemstoneWeight || "-"} ct × ₹{Details.gemCost || "-"}/ct
                                    ({Details.gemstoneType})
                                  </small>
                                </td>
                              </tr>
                            )}

                            {/* Hallmark Charges */}
                            {Details.hmTotal > 0 && (
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center gap-2">
                                    <i className="bi bi-shield-check text-danger"></i>
                                    <span>Hallmark Charges</span>
                                  </div>
                                </td>
                                <td className="text-end fw-semibold">
                                  ₹{Math.trunc(Details.hmTotal).toLocaleString('en-IN')}
                                </td>
                                <td>
                                  <small className="text-muted">BIS Certification</small>
                                </td>
                              </tr>
                            )}

                            {/* Taxes */}
                            {Details.saleTaxList?.map((tax, index) => (
                              <tr key={index}>
                                <td>
                                  <div className="d-flex align-items-center gap-2">
                                    <i className="bi bi-percent text-secondary"></i>
                                    <span>{tax.name}</span>
                                  </div>
                                </td>
                                <td className="text-end fw-semibold">
                                  ₹{Math.trunc(tax.amount).toLocaleString('en-IN')}
                                </td>
                                <td>
                                  <small className="text-muted">{tax.value}%</small>
                                </td>
                              </tr>
                            ))}

                            {/* Other Charges */}
                            {Details.otherCharge > 0 && (
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center gap-2">
                                    <i className="bi bi-plus-circle text-muted"></i>
                                    <span>Other Charges</span>
                                  </div>
                                </td>
                                <td className="text-end fw-semibold">
                                  ₹{Math.trunc(Details.otherCharge).toLocaleString('en-IN')}
                                </td>
                                <td>
                                  <small className="text-muted">{Details.otherChargeRemark || "Additional charges"}</small>
                                </td>
                              </tr>
                            )}

                            {/* Total Row */}
                            <tr className="table-primary">
                              <td className="fw-bold">
                                <div className="d-flex align-items-center gap-2">
                                  <i className="bi bi-currency-rupee"></i>
                                  <span>TOTAL AMOUNT</span>
                                </div>
                              </td>
                              <td className="text-end fw-bold fs-5">
                                ₹ {Math.trunc(Details.total).toLocaleString('en-IN')}
                              </td>
                              <td>
                                <small className="text-muted">Inclusive of all charges</small>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      {/* Summary Card */}
                      {/* <div className="mt-3">
                        <div className="card border-mgdm">
                          <div className="card-body">
                            <h6 className="card-title fw-bold mb-3">Price Summary</h6>
                            <div className="row g-3">
                              <div className="col-6">
                                <div className="d-flex justify-content-between">
                                  <span className="text-muted">Gold Rate Today:</span>
                                  <span className="fw-semibold">
                                    ₹{Details.todayRate?.toLocaleString('en-IN') || "-"}/gm
                                  </span>
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="d-flex justify-content-between">
                                  <span className="text-muted">Purity:</span>
                                  <span className="fw-semibold">{Details.goldPurity || "-"}</span>
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="d-flex justify-content-between">
                                  <span className="text-muted">Price per gram:</span>
                                  <span className="fw-semibold">
                                    ₹{(Details.total / Details.weight?.grossWeight || 0).toFixed(2)}
                                  </span>
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="d-flex justify-content-between">
                                  <span className="text-muted">Effective Rate:</span>
                                  <span className="fw-semibold">
                                    ₹{((Details.total / Details.weight?.grossWeight || 0) * (1000/916)).toFixed(2)} (24K equivalent)
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  )}

                  {/* Customization Tab */}
                {selectedTab === "customization" && (
  <div className="tab-pane fade show active">
    <div className="row g-3">
      {/* METAL – buttons */}
      <div className="col-md-6">
        <label className="form-label fw-semibold">Metal</label>
        <div className="d-flex flex-wrap">
          {["Gold", "Silver"].map((metal) => (
            <button
              key={metal}
              className={`btn btn-sm ${
                selectedMetal === metal ? "btn-custom-red" : "btn-outline-mgdm"
              }`}
              onClick={() => {
                setSelectedMetal(metal);
                setSelectedCategory("");
                setSelectedGender("");
                setSelectedSize("");
                setSelectedGrams("");
                setOpenCustomizationKey("");
              }}
            >
              {metal}
            </button>
          ))}
        </div>
      </div>

      {/* CATEGORY DROPDOWN */}
<div className="col-md-6">
  <label className="form-label fw-semibold">Category</label>

  <div className="position-relative">
    <div
      className={`border rounded px-3 py-2 d-flex justify-content-between align-items-center ${
        !isMetalSelected ? "bg-light" : ""
      }`}
      style={{
        cursor: isMetalSelected ? "pointer" : "not-allowed",
        opacity: isMetalSelected ? 1 : 0.6,
      }}
      onClick={() => {
        if (!isMetalSelected) return;
        setOpenCustomizationKey(
          openCustomizationKey === "category" ? "" : "category"
        );
      }}
    >
      <span>{selectedCategory || "Select"}</span>
      <i
        className={`bi bi-chevron-${
          openCustomizationKey === "category" ? "up" : "down"
        }`}
      />
    </div>

    {openCustomizationKey === "category" && (
      <div className="dropdown-overlay">
        {(selectedMetal === "Gold"
          ? getGoldProductCustomizationData().map((cat) => cat.name)
          : getSilverProductCustomizationData().map((cat) => cat.name)
        ).map((name) => (
          <div
            key={name}
            className="p-2 custom-option"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedCategory(name);
              setSelectedGender("");
              setSelectedSize("");
              setSelectedGrams("");
              setOpenCustomizationKey("");
            }}
          >
            {name}
          </div>
        ))}
      </div>
    )}
  </div>
</div>

{/* GENDER DROPDOWN */}
<div className="col-md-6">
  <label className="form-label fw-semibold">Gender</label>

  <div className="position-relative">
    <div
      className={`border rounded px-3 py-2 d-flex justify-content-between align-items-center ${
        !selectedCategory ? "bg-light" : ""
      }`}
      style={{
        cursor: selectedCategory ? "pointer" : "not-allowed",
        opacity: selectedCategory ? 1 : 0.6,
      }}
      onClick={() => {
        if (!selectedCategory) return;
        setOpenCustomizationKey(
          openCustomizationKey === "gender" ? "" : "gender"
        );
      }}
    >
      <span>{selectedGender || "Select"}</span>
      <i
        className={`bi bi-chevron-${
          openCustomizationKey === "gender" ? "up" : "down"
        }`}
      />
    </div>

    {openCustomizationKey === "gender" && (
      <div className="dropdown-overlay">
        {(() => {
          if (
            (selectedMetal === "Gold" || selectedMetal === "Silver") &&
            selectedCategory
          ) {
            const cat =
              selectedMetal === "Gold"
                ? getGoldProductCustomizationData().find(
                    (c) => c.name === selectedCategory
                  )
                : getSilverProductCustomizationData().find(
                    (c) => c.name === selectedCategory
                  );

            const genders = cat?.gender || [];

            if (!genders.length)
              return <div className="text-muted p-2">Not applicable</div>;

            return genders.map((g) => (
              <div
                key={g}
                className="p-2"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setSelectedGender(g);
                  setOpenCustomizationKey("");
                }}
              >
                {g}
              </div>
            ));
          }
        })()}
      </div>
    )}
  </div>
</div>

{/* SIZE DROPDOWN */}
<div className="col-md-6">
  <label className="form-label fw-semibold">Size</label>

  <div className="position-relative">
    <div
      className="border rounded px-3 py-2 d-flex justify-content-between align-items-center"
      style={{ cursor: "pointer" }}
      onClick={() =>
        setOpenCustomizationKey(
          openCustomizationKey === "size" ? "" : "size"
        )
      }
    >
      <span>{selectedSize || "Select"}</span>
      <i
        className={`bi bi-chevron-${
          openCustomizationKey === "size" ? "up" : "down"
        }`}
      />
    </div>

    {openCustomizationKey === "size" && (
      <div className="dropdown-overlay">
        {(() => {
          if (
            (selectedMetal === "Gold" || selectedMetal === "Silver") &&
            selectedCategory
          ) {
            const cat =
              selectedMetal === "Gold"
                ? getGoldProductCustomizationData().find(
                    (c) => c.name === selectedCategory
                  )
                : getSilverProductCustomizationData().find(
                    (c) => c.name === selectedCategory
                  );

            if (!cat?.data?.length)
              return <div className="text-muted p-2">Not available</div>;

            return cat.data.map((d, idx) => {
              const label = d.size ?? d.inches;
              const value =
                d.size !== undefined ? String(d.size) : String(d.inches);
              return (
                <div
                  key={idx}
                  className="p-2"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setSelectedSize(value);

                    if (Array.isArray(d.grams) && d.grams.length) {
                      setSelectedGrams(d.grams[0]);
                    } else if (typeof d.grams === "number") {
                      setSelectedGrams(d.grams);
                    } else {
                      setSelectedGrams("");
                    }

                    setOpenCustomizationKey("");
                  }}
                >
                  {label}
                </div>
              );
            });
          }
        })()}
      </div>
    )}
  </div>
</div>

{/* GRAMS DROPDOWN */}
<div className="col-md-6">
  <label className="form-label fw-semibold">Grams</label>

  <div className="position-relative">
    <div
      className={`border rounded px-3 py-2 d-flex justify-content-between align-items-center ${
        !selectedSize ? "bg-light" : ""
      }`}
      style={{
        cursor: selectedSize ? "pointer" : "not-allowed",
        opacity: selectedSize ? 1 : 0.6,
      }}
      onClick={() => {
        if (!selectedSize) return;
        setOpenCustomizationKey(
          openCustomizationKey === "grams" ? "" : "grams"
        );
      }}
    >
      <span>{selectedGrams ? `${selectedGrams}g` : "Select"}</span>
      <i
        className={`bi bi-chevron-${
          openCustomizationKey === "grams" ? "up" : "down"
        }`}
      />
    </div>

    {openCustomizationKey === "grams" && (
      <div className="dropdown-overlay">
        {(() => {
          if (
            (selectedMetal === "Gold" || selectedMetal === "Silver") &&
            selectedCategory &&
            selectedSize
          ) {
            const cat =
              selectedMetal === "Gold"
                ? getGoldProductCustomizationData().find(
                    (c) => c.name === selectedCategory
                  )
                : getSilverProductCustomizationData().find(
                    (c) => c.name === selectedCategory
                  );

            const item = cat?.data?.find((d) => {
              const v =
                d.size !== undefined ? String(d.size) : String(d.inches);
              return v === selectedSize;
            });

            const gramsArr = Array.isArray(item?.grams)
              ? item.grams
              : typeof item?.grams === "number"
              ? [item.grams]
              : [];

            if (!gramsArr.length)
              return <div className="text-muted p-2">Not available</div>;

            return gramsArr.map((g) => (
              <div
                key={g}
                className="p-2"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setSelectedGrams(g);
                  setOpenCustomizationKey("");
                }}
              >
                {g}g
              </div>
            ));
          }
        })()}
      </div>
    )}
  </div>
</div>


    </div>
  </div>
)}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Buying Guide Banner */}
    <div className="container my-5">
      <div className="position-relative rounded-3 overflow-hidden">
        <img
          src={ad}
          className="img-fluid w-100"
          alt="Buying Guide"
          style={{ height: "200px", objectFit: "cover" }}
        />
        <div className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center text-white p-4"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <h4 className="fw-bold mb-2">Not sure what to buy?</h4>
          <p className="mb-3">Let us help you in making that decision</p>
          <button
            className="btn btn-light px-4 py-2 d-flex align-items-center gap-2"
            onClick={handleButtonClick}
          >
            View Buying Guides
            <i className="bi bi-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>

    {/* Related Products */}
    <div className="container my-5">
      <RelatedProduct Details={Details} />
    </div>

    {/* Sticky Footer for Mobile */}
    {window.innerWidth < 768 && (
      <div className="fixed-bottom bg-white border-top shadow-lg p-3">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <div className="fw-bold">₹ {Math.trunc(Details.total || 0).toLocaleString('en-IN')}</div>
              <small className="text-muted">{Details.weight?.netWeight || "-"} gm</small>
            </div>
            <div className="d-flex gap-2">
              <button
                className="btn btn-outline-mgdm"
                onClick={() => navigate("/BookAnAppointment")}
              >
                <i className="bi bi-calendar-check me-1"></i>
                Book Now
              </button>
              <button
                className="btn btn-custom-red"
                onClick={() => addToCart(Details.productCode)}
              >
                <i className="bi bi-cart-plus me-1"></i>
                Add to Cart
              </button>
            </div>
          </div>
        </div>
      </div>
    )}
  </StyledDiv>
);
};